/**
 * Accessibility utilities for charts and data visualizations
 * WCAG 2.1 AA compliance helpers
 */
import { translateAdmin } from '../../../shared/i18n/translateAdmin.js';
import { formatNumber } from './dataFormatters.js';

/**
 * Generate ARIA label for chart
 */
export function generateChartAriaLabel(
  title: string,
  dataPointCount: number,
  description?: string
): string {
  const baseLabel = translateAdmin('analytics.accessibility.chartAriaBase', {
    title,
    count: dataPointCount,
  });
  return description ? `${baseLabel} ${description}` : baseLabel;
}

/**
 * Generate ARIA describedby text for chart
 */
export function generateChartDescription(
  chartType: string,
  dataCount: number,
  dateRange?: string
): string {
  let description = translateAdmin('analytics.accessibility.chartDescription', {
    chartType,
    count: dataCount,
  });
  if (dateRange) {
    description += translateAdmin('analytics.accessibility.chartDescriptionDateRange', {
      dateRange,
    });
  }
  description += translateAdmin('analytics.accessibility.chartDescriptionKeyboard');
  return description;
}

/**
 * Format value for screen reader
 */
export function formatForScreenReader(value: number, unit: string = ''): string {
  const formatted = formatNumber(value);
  return unit ? `${formatted} ${unit}` : formatted;
}
